/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Order } from './Order.js';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
} from './Order.js';

/**
 * 
 * @export
 * @interface GetOrdersResponse
 */
export interface GetOrdersResponse {
    /**
     * 
     * @type {Array<Order>}
     * @memberof GetOrdersResponse
     */
    data?: Array<Order>;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetOrdersResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetOrdersResponse interface.
 */
export function instanceOfGetOrdersResponse(value: object): boolean {
    return true;
}

export function GetOrdersResponseFromJSON(json: any): GetOrdersResponse {
    return GetOrdersResponseFromJSONTyped(json, false);
}

export function GetOrdersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrdersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrderFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetOrdersResponseToJSON(value?: GetOrdersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrderToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

